export interface IUpsellFormInput {
  type: string;
  name: string;
  placeholder: string;
  onChangeHandler: (e: { target: { value: string } }) => void;
}

export const UpsellFormInput = (props: IUpsellFormInput) => {
  const { type, name, placeholder, onChangeHandler } = props;
  return (
    <input
      automation-id="upsell-message-form-input"
      type={type}
      name={name}
      placeholder={placeholder}
      className="border-neutral-medium text-input-text h-8 w-full text-ellipsis rounded-sm border px-2 py-1 pr-10"
      onChange={onChangeHandler}
    ></input>
  );
};
